import type { StudentSummary } from '@/services/api/student-summary';
import { fetchApi } from '@/services/api-client';

export const ADMIN_EARLY_DISMISSALS_PATH = '/admin/early-dismissals';

export type EarlyDismissal = {
  id: string;
  studentId: string;
  student: StudentSummary | null;
  submittedByParentId: string | null;
  submittedByParentName: string | null;
  dismissalDate: string;
  dismissalTime: string;
  reason: string;
  /** The staff member who recorded it, or null when the family filed it themselves. */
  recordedByStaffId: string | null;
  createdAt: string;
};

export type AdminCreateEarlyDismissalData = {
  studentId: string;
  dismissalDate: string;
  dismissalTime: string;
  reason: string;
};

export const adminEarlyDismissalsApi = {
  list: (params: { studentId?: string } = {}) => {
    const qs = new URLSearchParams();
    if (params.studentId) qs.append('studentId', params.studentId);
    const s = qs.toString();
    return fetchApi<EarlyDismissal[]>(`${ADMIN_EARLY_DISMISSALS_PATH}${s ? `?${s}` : ''}`);
  },
  detail: (id: string) => fetchApi<EarlyDismissal>(`${ADMIN_EARLY_DISMISSALS_PATH}/${id}`),
  createOnBehalf: (data: AdminCreateEarlyDismissalData) =>
    fetchApi<EarlyDismissal>(ADMIN_EARLY_DISMISSALS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  remove: (id: string) => fetchApi<void>(`${ADMIN_EARLY_DISMISSALS_PATH}/${id}`, { method: 'DELETE' }),
};
